import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMedal } from "@fortawesome/free-solid-svg-icons";

const GrupoPropuestas = ({
  municipioId,
  munUrl,
  estado,
  tituloGrupo,
  //Muestra un botón "VOTAR" directo en cada tarjeta (etapa de votación pública).
  permitirVotar = false,
  //Renderiza el grupo dentro de un acordeón colapsable (para las archivadas).
  colapsable = false,
}) => {
  const [propuestas, guardarPropuestas] = useState([]);
  const [error, guardarError] = useState(false);

  useEffect(() => {
    const obtenerPropuestas = () => {
      axios
        .get(`/api/propuestas?municipioId=${municipioId}&estado=${estado}`)
        .then((respuesta) => {
          //Colocar en el state
          guardarPropuestas(respuesta.data.propuestas);
        })
        .catch((error) => guardarError(true));
    };
    obtenerPropuestas();
    return () => {
      guardarPropuestas([]);
    };
  }, [estado, municipioId]);

  if (!municipioId || propuestas.length === 0 || error) {
    return null;
  }

  const tarjetas = (
    <div className="row">
      {propuestas.map((propuesta) => (
        <div className="col-md-4 card-deck mx-auto" key={propuesta._id}>
          <div className="card mb-3">
            <img
              className="thumbnail ppr-img-thumbnail position-relative"
              src={`/api/public/${propuesta.img}`}
              alt={propuesta.titulo}
              loading="lazy"
            />
            {propuesta.estado === "seleccionada" && (
              <div className="overlay">
                <FontAwesomeIcon icon={faMedal} size="2x" />
              </div>
            )}

            <div className="card-body">
              {propuesta.eje && (
                <span className="badge badge-primary tag">{propuesta.eje}</span>
              )}

              <h3 className="card-title centrado">{propuesta.titulo}</h3>
              {/*Presupuesto con separador de miles, igual que la página de
                 propuesta (antes salía el número crudo).*/}
              <h6>
                PRESUPUESTO: ${propuesta.presupuesto.toLocaleString("es-AR")}
              </h6>
              <p className="card-text">{propuesta.subtitulo}</p>
              {propuesta.estado === "seleccionada" && (
                <p style={{ color: "#0a4797" }}>
                  <b>ESTADO DE EJECUCIÓN:</b> {propuesta.ejecucion}
                </p>
              )}
            </div>
            <div className="card-footer text-center">
              <Link
                to={`/municipio/${munUrl}/propuesta/${propuesta._id}`}
                className="btn ppr-btn-verde font-weight-bold m-1"
              >
                VER PROPUESTA
              </Link>
              {/*Atajo para votar sin pasar por la página de la propuesta.*/}
              {permitirVotar && (
                <Link
                  to={`/municipio/${munUrl}/votacion/${propuesta._id}`}
                  className="btn ppr-btn-azul font-weight-bold m-1"
                >
                  VOTAR
                </Link>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  //Variante colapsable (archivadas): acordeón nativo <details>, accesible y sin
  //JS. Como el componente ya devuelve null cuando no hay propuestas, el
  //acordeón nunca aparece vacío.
  if (colapsable) {
    return (
      <details className="grupo-archivadas">
        <summary>{tituloGrupo}</summary>
        <div className="mt-3">{tarjetas}</div>
      </details>
    );
  }

  return (
    <Fragment>
      <div className="row px-3 mb-4">
        <div className="col-md-12 m-2 ppr-titulo centrado">
          <h2 className="my-auto h4 mb-0">{tituloGrupo}</h2>
        </div>
      </div>
      {tarjetas}
    </Fragment>
  );
};

export default GrupoPropuestas;
